import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import * as dayjs from 'dayjs';

import PracticeContentPreview from '../../components/PracticeContentPreview'
import DateDialog from '../../components/shared/dateTimePicker';

import { getPractice, updatedPractice, createPractice } from '../../services/practices';

const PracticeEditor = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { teamId, id } = useParams();
  const { t } = useTranslation();
  const { date } = location?.state || {};

  const [practice, setPractice] = useState({ exercises_practices_attributes: [] });
  const [selectedDateTime, setSelectedDateTime] = useState({ date, hour: '17', minute: '00' });
  const [dataItem, setDataItem] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      if (!id) return;
      const { practice } = await getPractice(id);
      setPractice(practice);

      if (practice.scheduled_at) {
        const scheduledDate = dayjs(practice.scheduled_at.split('Z')[0]);;
        setSelectedDateTime({
          date: scheduledDate.toDate(),
          hour: scheduledDate.hour().toString().padStart(2, '0'),
          minute: scheduledDate.minute().toString().padStart(2, '0'),
        });
      }
    };

    loadData();
  }, [id]);

  const handleDateTimeChange = (date, hour, minute) => {
    setSelectedDateTime({ date: date || new Date(), hour: hour || '17', minute: minute || '00' });
  };

  const save = async () => {
    const formattedDate = dayjs(selectedDateTime.date).set('hour', selectedDateTime.hour).set('minute', selectedDateTime.minute).format('YYYY-MM-DDTHH:mm:ss');
    const filteredExercises = practice.exercises_practices_attributes?.map(({ practicable_type, practicable_id, position, id, _destroy }) => ({
      practicable_type,
      practicable_id,
      position,
      id,
      _destroy,
    })) || [];
  
    const practiceData = {scheduled_at: formattedDate, source_method: 'manual', team_id: teamId,exercises_practices_attributes: filteredExercises};
  
    try {
      if (practice?.practice_template?.exercises_practices) {
        await updatedPractice(id, { scheduled_at: formattedDate });
      } else if (filteredExercises.every(item => item.id === null)) {
        await createPractice(practiceData);
      } else {
        await updatedPractice(id, practiceData);
      }
      navigate(`/club_admin/teams/${teamId}`);
    } catch (error) {
      console.error('Error creating or updating practice:', error);
    }
  };
  
  return (
    <div className="form-container practice-form">
      <div className="form-container-header">{!id ? t('teams.create_team_practice') : t('teams.update_team_practice')}</div>
      <div className="form-container-header-title flex1">
        <div className="form-container-area-label" onClick={() => setDataItem(true)}>
          <div>
            {dayjs(selectedDateTime.date).format('dddd, D MMM YYYY')}, {selectedDateTime.hour}:{selectedDateTime.minute}
          </div>
          <div><i className="icon icon-calendar pointer"></i></div>
        </div>
      </div>

      <PracticeContentPreview practiceData={practice} setPracticeData={setPractice} libraries={['Exercise','Aktion','ExerciseCollection']}/>

      <div className="form-container-actions">
        <div className="flex-end">
          <button className="button" onClick={() => navigate(`/club_admin/teams/${teamId}`)}>{t('buttons.common.cancel')}</button>
          {id ? (
            <button className="button button-primary" onClick={save}>{t('buttons.common.update')}</button>
          ) : (
            <button className="button button-primary" onClick={save}>{t('buttons.common.save')}</button>
          )}
        </div>
      </div>

      {dataItem === true && (
        <DateDialog
          close={() => setDataItem(false)}
          onDateTimeChange={handleDateTimeChange}
          method=""
          initialDateTime={{
            date: selectedDateTime.date,
            hour: selectedDateTime.hour,
            minute: selectedDateTime.minute,
          }}
        />
      )}
    </div>
  );
};

export default PracticeEditor;
